import React, { Component } from 'react';

import { connect } from 'react-redux';
import InsightDescriptions from 'modules/HorseRacing/components/InsightDescriptions';

@connect(
  state => {
    return {
      insights: state.horseRacing.insights
    };
  }
)
export default class InsightDescriptionsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  componentDidMount() {
    var selectedId = window.location.hash.replace('#', '');
    this.setState({selectedId: selectedId});
  }

  render() {
    return (
      <InsightDescriptions {...this.props} {...this.state}/>
    );
  }
}




// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/InsightDescriptionsContainer.js